import { z } from 'zod';

export { zodActivationRequestResponseSchema } from '../validations';

export const zodUpdateActivationAutoFollowUpPayloadSchema = z.object({
  autoFollowUp: z.boolean(),
});
